import { CAST_AI } from '@cast/constants';
import { Button, Icons, MarketingBanner } from '@cast/design-system';
import { useAbility } from '@cast/shared-ability-data-access';
import {
  CREATE_ALERT_ACTION_KEY,
  CREATE_ALERT_ACTION_VALUE,
} from 'features/notifications/_hooks/useNavigateToCreateAlert';
import { useNavigate } from '@cast/infrastructure-organization';

import { getDocsLink } from '@cast/utils';

export const SLACK_ANNOUNCEMENT_BANNER_ID = 'slack-announcement-notification';

export const SlackAnnouncementBanner = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const ability = useAbility();
  const navigate = useNavigate();

  const canCreateAlert = ability.can('create', 'OrganizationWebHooks');

  const handleGetStarted = () => {
    navigate(
      `/notifications?${CREATE_ALERT_ACTION_KEY}=${CREATE_ALERT_ACTION_VALUE}`
    );
  };

  return (
    <MarketingBanner
      testId={SLACK_ANNOUNCEMENT_BANNER_ID}
      title={`Get ${CAST_AI} alerts in Slack`}
      message={`Get notified about cluster events where your team already works. Connect your workspace in a few clicks and get ${CAST_AI} notifications in any channel.`}
      action={
        <Button
          size="sm"
          endIcon={<Icons.ArrowRight />}
          {...(canCreateAlert
            ? { onClick: handleGetStarted }
            : {
                component: 'a',
                href: getDocsLink('docs_slack_notifications'),
                target: '_blank',
              })}
        >
          Get started
        </Button>
      }
      onClose={onClose}
    />
  );
};
